import React from 'react';
import { FaStar } from 'react-icons/fa';

// Array of review objects
const reviews = [
  {
    name: 'Shreya Shashikant Panmand',
    institution: 'Modern college of Pune BBACA',
    rating: 5,
    text: 'Great experience of this class such amazing class teacher an all they help to students to grow up I am thankful to Internselite.',
  },
  {
    name: 'Sahil Gupta',
    institution: 'Chandigarh Engineering College, Mohali, (B.tech in Information Technology)',
    rating: 4,
    text: 'I recently completed the web development course at Internselite and I am extremely happy with the results. I learned everything I need to know to start building my own websites, from HTML and CSS to JavaScript. The instructor was knowledgeable and engaging, and he made sure that everyone in the class understood the concepts. I would highly recommend this course to anyone who is interested in learning web development.',
  },
  {
    name: 'P. Madhavi',
    institution: 'Sri Krishna Devaraya University, B.tech(CSE)',
    rating: 5,
    text: 'In this internship they provided content is well structured and time management and time table is very well structured. Over all it is like a game changer to me, finally it\'s been fantastic.',
  },
  {
    name: 'Priya Arya',
    institution: 'Guru Nanak Dev University, Regional Campus Gurdaspur, (CSE)',
    rating: 4,
    text: 'It was a nice journey, I learnt so well and the efforts of the teachers are inestimable',
  },
  {
    name: 'Mohd Aaquid Faisal Shaikh A Rasheed',
    institution: 'Dr D Y Patil College of Engineering and Innovation Varale Pune, Computer Engineering',
    rating: 5,
    text: 'It was a great Training,Thank you so much for an amazing course, I learned so much and you made even the more complex topics interesting and easier to follow through real world stories and case studies. The course and all the materials are both comprehensive and informative.',
  },
  {
    name: 'Vivek Chaturvedi',
    institution: 'CSE',
    rating: 4,
    text: 'Impressed by Internslite\'s Full Stack Developer\'s exemplary skills in front-end and back-end technologies, including JavaScript, React, and Node.js. Their seamless interface creation, problem-solving, and collaborative approach made the internship enriching. Highly recommend their top-notch expertise in web development.',
  },
];

function MS_Review_Program_Page() {
  return (
    <div>
      <div>
        <div className='container'>
          <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
              <div className='text-center review_component_text'>
                <h2 className='display-5 pb-2'>Testimonial</h2>
                <p className='fs-6'>
                  Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.
                </p>
              </div>
            </div>
            <div className='col-md-1'></div>
          </div>
          <div className='row'>
            <div className='col-md-4 pt-5'>
              <div className='Program_review_comp'>
                <div className='mt-5 px-5 review_component_text'>
                  <h2 className='pt-5 display-6'>Hear What Our Students Says</h2>
                  <p className='pt-4 fs-5'>25K+ Students have already learned with InternsElite</p>
                </div>
              </div>
            </div>
            <div className='col-md-8'>
              <div className='row'>
                {reviews.map((review, index) => (
                  <div key={index} className={`col-md-${index % 2 === 0 ? '5' : '7'} card`}>
                    <div className='card-body'>
                      <h5 className='font-weight-bold Review_not_copy'>{review.name}</h5>
                      <h6 className='font-weight-bold my-2 Review_not_copy'>{review.institution}</h6>
                      <ul className='list-unstyled d-flex justify-content-start Review_not_copy'>
                        {[...Array(5)].map((_, i) => (
                          <li key={i}>
                            <FaStar color={i < review.rating ? 'gold' : undefined} />
                          </li>
                        ))}
                      </ul>
                      <p className='Review_not_copy'>
                        <i className='fas fa-quote-left pe-2'></i>{review.text}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MS_Review_Program_Page;
